import React, { useEffect, useState } from "react";
import ProjectDropdown from "../common/ProjectDropdown";
import { connect, useSelector } from "react-redux";
import {getDashboard} from '../../actions/dashboard';
import OngoingCounts from "./OngoingCounts";
import IncomeAndExpenses from "./IncomeAndExpenses";
import InvoiceStages from "./InvoiceStages";
import {setActiveSidebarPage} from "../../actions/core";
import {Redirect} from "react-router-dom";
import {logout} from "../../actions/auth";


export function Dashboard(props) {

    // GLOBAL STATE --------------------------------------------------------------------------------------------------------------------------
    const status = useSelector((state) => state.auth.status);
    const project = useSelector(state => state.projects.project);
    const dashboard = useSelector(state => state.dashboard.dashboard);
    const [showDash, setShowDash] = useState(false);

    // when the component mounts, start to load the dashboard information
    useEffect(() => {
        props.setActiveSidebarPage("dashboard");
        props.getDashboard();
    }, [])

    // show dashboard once data is loaded (dashboard can only be rendered if the store contains data)
    useEffect(() => {
        if(Object.keys(dashboard).length > 0) setShowDash(true); 
    }, [dashboard])

    return (
        <div className={status === "authenticated" ? "page-wrapper" : "flex-column center" }>
            {showDash &&
            <>
                <div className="header-div">
                    <div>
                        <div  className="iblock vtop">
                            <h1 className="header title heavy iblock">Dashboard </h1>
                        </div>
                        {/* <div className="iblock vtop"> 
                            <ProjectDropdown />
                        </div> */}
                    </div>
                </div>
                <div className="flex-row">
                    <OngoingCounts />
                    <InvoiceStages />
                </div>
                <IncomeAndExpenses />
            </>
            }
        </div>
    )
}

const mapStateToProps = () => ({})


export default connect(mapStateToProps, {getDashboard, setActiveSidebarPage, logout})(Dashboard);